import { buildLink } from '@/helpers/slugHelper';
import React from 'react'
import styles from "../common/Breadcrumbs/Breadcrumbs.module.scss"

// Define the paths for which breadcrumbs should be hidden
export const collectionPath = [
  "/designer",
  "/new-arrivals",
  "/search",
  "/collection",
  "/sale",
];

function getCollectionFromFilters(filters) {
  const lvl0 = filters['p.f.pr.named_tags."categories.lvl0"'];
  const lvl1 = filters['p.f.pr.named_tags."categories.lvl1"'];
  const lvl2 = filters['p.f.pr.named_tags."categories.lvl2"'];

  // Helper to check if all values in an array are the same (case-insensitive)
  const allValuesSame = arr => {
    if (!Array.isArray(arr) || arr.length < 2) return true;
    const first = arr[0].toLowerCase();
    return arr.every(v => v.toLowerCase() === first);
  };

  // Only lvl0 present and one value
  if (lvl0 && lvl0.length === 1 && (!lvl1 || lvl1.length === 0) && (!lvl2 || lvl2.length === 0)) {
    return lvl0[0];
  }

  // lvl0 and lvl1 present, lvl2 absent
  if (lvl0 && lvl1 && lvl1.length > 0 && (!lvl2 || lvl2.length === 0)) {
    if (lvl1.length === 1 || allValuesSame(lvl1)) {
      return lvl1[0];
    } else {
      // Multiple distinct values in lvl1
      return lvl0[0];
    }
  }

  // lvl0, lvl1, lvl2 present
  if (lvl0 && lvl1 && lvl2 && lvl2.length > 0) {
    if (lvl2.length === 1 || allValuesSame(lvl2)) {
      return lvl2[0];
    } else {
      if (lvl1.length === 1 || allValuesSame(lvl1)) {
        return lvl1[0];
      } else {
        // Multiple distinct values in lvl1
        return lvl0[0];
      }
    }
  }

  // Fallback: return lvl0 if present
  if (lvl0 && lvl0.length > 0) return lvl0[0];

  return null;
}

function BreadCrumb(props) {
  const items  = props.filters
  let collectionName = getCollectionFromFilters(items)
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);
  const [flag, setFlag] = React.useState(false);
  const [shouldHideBreadcrumbs, setShouldHideBreadcrumbs] = React.useState(false);
  let breadCrumbsArr = null;
  let ret = [];

  // Check if the current URL path is in the collectionPath array
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathShouldHide = collectionPath.some(path => window.location.pathname.includes(path));
      // Set shouldHideBreadcrumbs to true if pathShouldHide is true, otherwise false
      setShouldHideBreadcrumbs(!pathShouldHide);
    }
  }, []);

  // Function to create breadcrumb links without accumulating levels
  const createBreadcrumbLinks = async () => {
    breadCrumbsArr = collectionName.split(">")
    let link = "/products";
    if(breadCrumbsArr?.length > 2) {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim());
      ret.push( {
        link: link,
        text: breadCrumbsArr[1],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim(),breadCrumbsArr[2]?.trim());
      ret.push( {
            link: link,
            text: breadCrumbsArr[2],
          })
      setBreadcrumbs(ret)
      setFlag(false)
    } 
    else if(breadCrumbsArr?.length > 1) {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })

      link = await buildLink(breadCrumbsArr[0]?.trim(),breadCrumbsArr[1]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[1],
      })
      setBreadcrumbs(ret)
      setFlag(false)
    } else if(breadCrumbsArr?.length) {
      link = await buildLink(breadCrumbsArr[0]?.trim());
      ret.push({
        link: link,
        text: breadCrumbsArr[0],
      })
      setBreadcrumbs(ret)
      setFlag(false)
    }
  };

  const setBredCrumb = async () => {
    await createBreadcrumbLinks();
  }

  React.useEffect(() => {
    /* data must contain either level0, 1 or 2 level attribute */
    if(collectionName) {
      //OS-4968 #timeout is added to prevent multiple function call
      if(!flag){
        setFlag(true)
        setTimeout(() => {
          setBredCrumb();
        }, 1000);
      }
    }
  }, [collectionName]);

  // Render the breadcrumbs or null based on shouldHideBreadcrumbs state
  return shouldHideBreadcrumbs ? (
    // If shouldHideBreadcrumbs is true, render the breadcrumbs section
    <section className={`${styles.breadcrumb_sec}`}>
      <div className="container-fluid mw-1440">
        <div className="row">
          <nav className="grid-md-12 grid-sm-12" aria-label="breadcrumbs">
            <ol className={`xx-small`}>
              {breadcrumbs.map((breadcrumb, index) => (
                <li key={index}>
                  {index === breadcrumbs.length - 1 ? (
                    <span>
                      {breadcrumb.text
                        ? breadcrumb.text.charAt(0).toUpperCase() +
                          breadcrumb.text.slice(1).replaceAll("-", " ")
                        : null}
                    </span>
                  ) : (
                    <a href={breadcrumb.link} tabIndex={0} className="breadcrumb-link">
                      {breadcrumb.text
                        ? breadcrumb.text.charAt(0).toUpperCase() +
                          breadcrumb.text.slice(1).replaceAll("-", " ")
                        : null}
                    </a>
                  )}
                  {index < breadcrumbs.length - 1 }
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
    </section>
  ) : <></>;  // If shouldHideBreadcrumbs is false, return null (hide breadcrumbs)
}

export default BreadCrumb